import { UserManager, type UserManagerSettings } from "oidc-client-ts";

let logisticsApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_LOGISTICS_BACKEND
    ? () => `https://localhost:7240/care`
    : (organization: string) =>
        `https://logistics-${organization}-dev.medoma.com/care`;

let logisticsSseUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_LOGISTICS_BACKEND
    ? () => `https://localhost:7240/care`
    : (organization: string) =>
        `https://logisticsbg-${organization}-dev.medoma.com/care`;
let notificationApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_LOGISTICS_BACKEND
    ? () => `https://localhost:7240/notification/care`
    : (organization: string) =>
        `https://logistics-${organization}-dev.medoma.com/notification/care`;

let patientApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_PATIENTS_BACKEND
    ? () => `https://localhost:7023/care`
    : (organization: string) =>
        `https://pas-${organization}-dev.medoma.com/care`;

let authApiUrl =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_AUTH_BACKEND
    ? `https://localhost:5001`
    : `https://auth-dev.medoma.com`;

let environment = import.meta.env.DEV ? "local" : "dev";

const hostname = window?.location?.hostname;

// Inspired by https://daveceddia.com/multiple-environments-with-react/
if (hostname === "care.medoma.com") {
  authApiUrl = `https://auth.medoma.com`;
  logisticsApiUrl = (organization: string) =>
    `https://logistics-${organization}.medoma.com/care`;
  logisticsSseUrl = (organization: string) =>
    `https://logisticsbg-${organization}.medoma.com/care`;
  notificationApiUrl = (organization: string) =>
    `https://logistics-${organization}.medoma.com/notification/care`;
  patientApiUrl = (organization: string) =>
    `https://pas-${organization}.medoma.com/care`;
  environment = "prod";
} else if (hostname === "care.test.medoma.com") {
  authApiUrl = `https://auth-test.medoma.com`;
  logisticsApiUrl = (organization: string) =>
    `https://logistics-${organization}-test.medoma.com/care`;
  logisticsSseUrl = (organization: string) =>
    `https://logisticsbg-${organization}-test.medoma.com/care`;
  notificationApiUrl = (organization: string) =>
    `https://logistics-${organization}-test.medoma.com/notification/care`;
  patientApiUrl = (organization: string) =>
    `https://pas-${organization}-test.medoma.com/care`;
  environment = "test";
}

const scopes = [
  // accessLogisticsApiAsPatient
  "logistic.api",
  // accessPatientApiAsPatient
  "patient.api",
  // userProfile
  "openid",
  // Custom scope required for auth service to differentiate between old patient/OTP-based login and new device-based login
  "user_type",
  // To get the organization the user belongs to
  "organization",
  "mfa",
  "issued_for_app",
  // To get the organization the user belongs to
  "organization",
];
const oidcConfig: UserManagerSettings = {
  authority: authApiUrl,
  client_id: "medoma-care-reference",
  redirect_uri: `${window.location.origin}/login`,
  // https://authts.github.io/oidc-client-ts/interfaces/UserManagerSettings.html#scope
  scope: scopes.join(" "),
};

export const userManager = new UserManager(oidcConfig);

export const {
  getLogisticsApiUrl,
  getLogisticsSseUrl,
  getPatientApiUrl,
  getNotificationApiUrl,
  AUTH_API_URL,
  ENVIRONMENT,
} = {
  getLogisticsApiUrl: (organization: string) => logisticsApiUrl(organization),
  getLogisticsSseUrl: (organization: string) => logisticsSseUrl(organization),
  getPatientApiUrl: (organization: string) => patientApiUrl(organization),
  getNotificationApiUrl: (organization: string) =>
    notificationApiUrl(organization),
  AUTH_API_URL: authApiUrl,
  ENVIRONMENT: environment,
};
